import { DragDropModule } from '@angular/cdk/drag-drop';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ActivityCommentComponent } from '@app/task-shared/components/task-detail/components/activity-comment/activity-comment.component';
import { ActivityHistoryComponent } from '@app/task-shared/components/task-detail/components/activity-history/activity-history.component';
import { AddTaskLinkComponent } from '@app/task-shared/components/task-detail/components/add-task-link/add-task-link.component';
import { InputContentComponent } from '@app/task-shared/components/task-detail/components/input-content/input-content.component';
import { LinkTaskItemComponent } from '@app/task-shared/components/task-detail/components/link-task-item/link-task-item.component';
import { SubPanelComponent } from '@app/task-shared/components/task-detail/components/sub-panel/sub-panel.component';
import { SubTaskItemComponent } from '@app/task-shared/components/task-detail/components/sub-task-item/sub-task-item.component';
import { TaskAttachmentsComponent } from '@app/task-shared/components/task-detail/components/task-attachments/task-attachments.component';
import { TaskCreateFormComponent } from '@app/task-shared/components/task-detail/components/task-create-form/task-create-form.component';
import { TaskCreateComponent } from '@app/task-shared/components/task-detail/components/task-create/task-create.component';
import { TaskDetailDialogComponent } from '@app/task-shared/components/task-detail/components/task-detail-dialog/task-detail-dialog.component';
import { AssignMemberComponent } from '@app/task-shared/components/task-detail/components/task-fields/components/assign-member/assign-member.component';
import { DateSelectComponent } from '@app/task-shared/components/task-detail/components/task-fields/components/date-select/date-select.component';
import { FieldItemComponent } from '@app/task-shared/components/task-detail/components/task-fields/components/field-item/field-item.component';
import { FileUploadComponent } from '@app/task-shared/components/task-detail/components/task-fields/components/file-upload/file-upload.component';
import { LabelSelectComponent } from '@app/task-shared/components/task-detail/components/task-fields/components/label-select/label-select.component';
import { ResourceTreeSelectComponent } from '@app/task-shared/components/task-detail/components/task-fields/components/resource-tree-select/resource-tree-select.component';
import { TaskCheckboxComponent } from '@app/task-shared/components/task-detail/components/task-fields/components/task-checkbox/task-checkbox.component';
import { ZSelectComponent } from '@app/task-shared/components/task-detail/components/task-fields/components/z-select/z-select.component';
import { TaskFieldsComponent } from '@app/task-shared/components/task-detail/components/task-fields/task-fields.component';
import { TaskTesterComponent } from '@app/task-shared/components/task-detail/components/task-tester/task-tester.component';
import { TaskDetailComponent } from '@app/task-shared/components/task-detail/task-detail.component';
import { SharedModule } from '@shared';
import { NgxGanttModule } from '@worktile/gantt';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzEmptyComponent } from 'ng-zorro-antd/empty';
import { NzTreeSelectComponent } from 'ng-zorro-antd/tree-select';
import { QuillModule } from 'ngx-quill';
import { TaskResourcesComponent } from './components/task-detail/components/task-resources/task-resources.component';
import { FilterMemberComponent } from '@app/task-shared/components/filter-member/filter-member.component';
import { TaskFilterItemComponent } from '@app/task-shared/components/task-filter-item/task-filter-item.component';

const CustomComponents = [
  TaskDetailDialogComponent,
  ActivityCommentComponent,
  ActivityHistoryComponent,
  AddTaskLinkComponent,
  InputContentComponent,
  LinkTaskItemComponent,
  SubPanelComponent,
  SubTaskItemComponent,
  TaskAttachmentsComponent,
  TaskCreateComponent,
  TaskCreateFormComponent,
  TaskFieldsComponent,
  AssignMemberComponent,
  DateSelectComponent,
  FieldItemComponent,
  FileUploadComponent,
  LabelSelectComponent,
  ResourceTreeSelectComponent,
  TaskCheckboxComponent,
  ZSelectComponent,
  TaskTesterComponent,
  TaskDetailDialogComponent,
  TaskDetailComponent,
  FilterMemberComponent,
  TaskFilterItemComponent
];

@NgModule({
  declarations: [
    ...CustomComponents,
    TaskResourcesComponent,
    TaskTesterComponent
  ],
  exports: [
    TaskDetailDialogComponent,
    TaskCreateComponent,
    ResourceTreeSelectComponent,
    FilterMemberComponent,
    TaskFilterItemComponent,
    TaskTesterComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    NzTreeSelectComponent,
    DragDropModule,
    ScrollingModule,
    NzCollapseModule,
    QuillModule.forRoot(),
    NzEmptyComponent,
    NgxGanttModule,
  ],
})
export class TaskSharedModule { }
